import type { InvoicePeriodGranularity } from "../types";

export const PERIOD_GRANULARITY_BY_FILTER: Record<string, InvoicePeriodGranularity> = {
  current_month: "monthly",
  previous_month: "monthly",
  current_quarter: "quarterly",
  previous_quarter: "quarterly",
  current_fy: "yearly",
  previous_fy: "yearly",
  custom: "monthly",
};

export const getPeriodGranularity = (filterType?: string): InvoicePeriodGranularity =>
  PERIOD_GRANULARITY_BY_FILTER[filterType || ""] || "monthly";
